export class PatientEstimateItemBase {
  price: string;
  estimate_id: number;
  appointment_index: number;
  description: string;
  id: number;
  position: number;
  tooth_location: string;
}

export class PatientEstimateBase {
  template_name: string;
  patient_id: number;
  practitioner_id: number;
  created_at: string;
  description: string;
  signed: boolean;
  estimate_items: Array<PatientEstimateItemBase>;
  footnote: string;
  payment_terms: string;
  id: number;
  nhs_value: string;
  treatment_plan_id: number | null;
  html: string | null;
  treatment_plan_completed: boolean;
}
